import React from 'react';
import { APP_URLS, AUTH_KEY, NOT_AUTHORIZED_ERROR } from '../../constants/constants';
import { endSessionAndRedirect, getTransactionIdFromURL, getValueFromLocalStorage, isUserLoggedIn, handleUnauthorized } from '../../constants/utils';
import Loader from '../loader/loader';

export default function withTokens(Component: any) {

  return class extends React.Component<any> {
    state = { loading: true, loaded: false, isUnauthorized: false };
    txnId = getTransactionIdFromURL();
    token = getValueFromLocalStorage(AUTH_KEY(this.txnId));

    componentDidMount() {
      const locationState = this.props.location.state;
      if (locationState !== undefined && locationState.errorCode === NOT_AUTHORIZED_ERROR.code) {
        this.setState({
          isUnauthorized: true
        })
      }
      if (this.validToken()) {
        this.setState({ loading: false, loaded: true });
      } else {
        this.setState({ loading: false });
      }
    }

    validToken(): boolean {
      return isUserLoggedIn(this.txnId)
    }

    checkAuthorization() {
      let values = Object.values(APP_URLS)
      if (this.validToken() && values.includes(this.props.match.path)) {
        return true;
      }
      return false;
    }

    check() {
      if (this.state.isUnauthorized) {
        return <Component {...this.props} />
      }
      if (this.state.loaded) {
        if (this.checkAuthorization()) {
          return <Component {...this.props} />
        }
        else {
          // Will be routed to error page for Unauthorized Access.
          handleUnauthorized(APP_URLS.UNAUTHORIZED);
        }
      } else {
        // Will be routed to error page for Common error
        endSessionAndRedirect(APP_URLS.COMMON_ERROR)
      }
    }

    render() {
      return (
        <>{
          this.state.loading
            ?
            <Loader />
            :
            this.check()
        }</>
      );
    }

  }
}
